// tanstack
import { toolDefinition } from '@tanstack/ai';

import { z } from 'zod';

/**
 * Client-side tool to get the currently selected account from Redux state
 * This tool executes in the browser and has access to the application state
 */
export const getCurrentAccountDef = toolDefinition({
  name: 'get_account',
  description:
    'Get the currently selected account ID and basic account information. Use this tool to find out which account the user is currently viewing. This tool executes in the browser and has access to the current application state. IMPORTANT: After calling this tool, you MUST explain to the user which account is currently selected, including the account name and ID. Present this information in a natural, conversational way. This is essential for providing context in subsequent tool calls that require an accountId.',
  inputSchema: z.object({}), // No input needed
  outputSchema: z.object({
    accountId: z.number().describe('The currently selected account ID'),
    accountName: z.string().optional().describe('The accountName if available'),
    hasAccount: z.boolean().describe('Whether an account is selected'),
  }),
  // needsApproval: true,
});
